module.exports = __webpack_public_path__ + "static/media/icon_location_yulei.02f5eee0.png";